import { useEffect, useState, useContext } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
// import { Line } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
// import { faker } from "@faker-js/faker";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useNavigate } from 'react-router-dom';


// import dayjs from "dayjs";

// import faker from 'faker';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarGraph = ({ mobileView,barData,clickData }) => {
  const navigate = useNavigate();

  //   const [labels, setLabels] = useState([]);

  //   useEffect(() => {
  //     if (chart_data?.totaluserWithLinksCreatedMoreThanFive) {
  //       const xkeys = Object.keys(
  //         chart_data?.totaluserWithLinksCreatedMoreThanFive
  //       )?.map((item) => {
  //         return item;
  //       });
  //       setLabels(xkeys);
  //     }
  //   }, [chart_data]);


  const labels = [
    "Visited",
    "Conversation",
    "Leads",
    // "Meeting Setup",
    // "Closed",
    // "Lost",
  ];
  const bgColor = [
    "#701A75",
    "#A21CAF",
    "#C026D3",
    "#D946EF",
    "#E879F9",
    "#F0ABFC",
  ];

  const options = {
    onHover: (event, chartElement) => {
      if (chartElement.length) {
          const index = chartElement[0].index;
          const datasetIndex = chartElement[0].datasetIndex;
          // Change the cursor to pointer only for bars with a specific background color
          if (data.datasets[datasetIndex].backgroundColor[index] === '#701A75') {
              event.native.target.style.cursor = 'default';
          } else {
              event.native.target.style.cursor = 'pointer';
          }
      } else {
          event.native.target.style.cursor = 'default';
      }
  },
    layout: {
      padding: {
        top: 20, // Adjust the top padding as needed
      },
    },
    plugins: {
      tooltip: {
        enabled: true,
      },
      legend: {
        display: false,
      },
      title: {
        display: false,
        // text: chartName,
      },
      datalabels: {
        display: true,
        color: "black",
        formatter: Math.round,
        anchor: "end",
        offset: -20,
        align: "start",
      },
    },
    
    responsive: true,
    scales: {
      x: {
        grid: {
          display: false,
        },
        border: {
          display: false,
        },
      },
      y: {
        grid: {
          display: true,
        },
        border: {
          display: true,
        },
        ticks: {
          display: false
      },
        display: true, // Hide the y-axis
      },
    },
    onClick: (event, elements) => {
      if (elements.length > 0) {
        // handleClick()
        // Get the index of the clicked bar
        const clickedBarIndex = elements[0].index;
        if(clickedBarIndex == 1){
          navigate('/Conversation', { state:clickData });
        }else if(clickedBarIndex == 2){
          navigate('/Lead-Management', { state:clickData });
        }
        // Do something with the clicked bar, for example, log its index
        // console.log("Clicked bar index:", clickedBarIndex);
      }
    },
  };

  const data = {
    labels,
    datasets: [
      // {
      //   label: "Total Users with Links Created",
      //   data: Object.keys(chart_data?.totalActiveUserWithLinksCreated).map(
      //     (item) => chart_data.totalActiveUserWithLinksCreated[item]
      //   ),
      //   borderColor: "#701A75",
      //   backgroundColor: "#FFC652",
      //   yAxisID: "y",
      // },
      {
        label: "Users A",
        data: barData.map((item) => item),
        borderColor: bgColor.map((item) => item),
        backgroundColor: bgColor.map((item) => item),
        borderWidth: 1,
        borderSkipped: false,
        borderRadius: 15,
        yAxisID: "y",
        barThickness: mobileView ? 40:80,
      },
    ],
  };

  return (
    <Bar
      options={options}
      data={data}
      width={100}
      height={30}
      plugins={[ChartDataLabels]}
    />
  );
};
export default BarGraph;
